const Priorites = [
    { key: 'Routine', value: 'Routine', text: 'Routine' },
    { key: 'Urgent', value: 'Urgent', text: 'Urgent' },
    { key: 'Emergency', value: 'Out Of Hours', text: 'Emergency' },
    { key: '24 Hours', value: '24', text: '24 Hours' },

  

  ]


export default Priorites;
